import React from 'react';
import { BaseCard } from '@/components/uiKit/Cards';
import { AlarmsTable } from './AlarmsTable';
import { Skeleton } from '@/components/ui/skeleton';

function AlarmsTableEmptyState() {
  return (
    <div className="w-full h-full bg-white dark:bg-[#52606d] flex justify-center items-center flex-col">
      No alarms found for the selected time range or filters
    </div>
  );
}

export function AlertsTableCard({
  tableData,
  isLoading,
  isError,
}: {
  tableData: any;
  isLoading: boolean;
  isError: boolean;
}) {
  if (isLoading) return <Skeleton className="min-h-0 h-full" />;
  return (
    <BaseCard
      // title={<CardDropdown items={tableItems} onSelect={(item: { id: TableGroupBy }) => setTableType(item.id)} />}
      classNames={{
        card: 'w-full h-full p-2 relative flex flex-col overflow-hidden',
        content: 'w-full flex-1 p-0 bg-gray-200 dark:bg-[#2f3844] overflow-hidden', // Added overflow-hidden
      }}
      variant="wrapper"
    >
      {tableData?.length > 0 ? (
        <div className="w-full h-full overflow-hidden ">
          <AlarmsTable tableData={tableData || []} />
        </div>
      ) : (
        <AlarmsTableEmptyState />
      )}
    </BaseCard>
  );
}
